import { isSafeDeepLink } from "./foregroundWalletApp.js";
/**
 * Bridges a `display_uri` event source to the shared QR state shape, with
 * mobile deep-link fallback. Returns an unsubscribe function.
 *
 * The caller is expected to have already emitted `{ state: 'loading' }` before
 * invoking this helper.
 */
export function subscribeDisplayUri(params) {
    const { source, resolveURI, isMobilePlatform, onQr } = params;
    return source.onDisplayUri((uri) => {
        const deepLink = resolveURI ? resolveURI(uri) : undefined;
        if (isMobilePlatform && deepLink) {
            if (!isSafeDeepLink(deepLink)) {
                console.warn('Blocked navigation to untrusted or malformed URL');
                onQr({ state: 'fetched', value: uri, deepLink });
                return;
            }
            window.location.href = deepLink;
            return;
        }
        onQr({ state: 'fetched', value: uri, deepLink });
    });
}
